<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="form"
    class="migrate-domain-form onsip-grid-placement"
    (ngSubmit)="onSubmitModal()"
  >
    <div class="option-wrapper">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.DOMAIN_TYPE" | translate }}</div>
      <mat-radio-group color="primary" formControlName="domainType">
        <section class="with-mat-form-field sip-address">
          <mat-radio-button [value]="domainTypeValues.sipDomain" class="radio-container">
            <span class="radio-option">{{
              "ONSIP_I18N.SELECT_AN_ONSIP_SUBDOMAIN" | translate
            }}</span>
          </mat-radio-button>
          @if (form.controls.domainType.value === domainTypeValues.sipDomain) {
          <div class="field-wrapper">
            <mat-form-field
              onsip-form-field-infix-auto
              onsip-form-field-flush-outline
              appearance="outline"
              class="sip-domains-select"
            >
              <mat-select formControlName="sipDomain">
                @for (sipDomain of sipDomains; track sipDomain) {
                <mat-option [value]="sipDomain">
                  {{ sipDomain }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="suffix">{{ defaultDomain }}</span>
          </div>
          }
        </section>
        <section class="with-mat-form-field">
          <mat-radio-button [value]="domainTypeValues.privateDomain" class="radio-container">
            <span class="radio-option">{{
              "ONSIP_I18N.USE_YOUR_OWN_PRIVATE_DOMAIN" | translate
            }}</span>
          </mat-radio-button>
          @if (form.controls.domainType.value === domainTypeValues.privateDomain) {
          <mat-form-field onsip-form-field-infix-auto appearance="outline" class="filed-grid">
            <input matInput formControlName="privateDomain" autocomplete="off" />
            <mat-error>{{ "ONSIP_I18N.DOMAIN_IS_REQUIRED" | translate }}</mat-error>
          </mat-form-field>
          }
        </section>
      </mat-radio-group>
    </div>
    <div class="actions-wrapper">
      <button mat-button color="primary" type="button" (click)="cancel()">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit">
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
